import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { ItemScopeToolbar } from '@app/purchased-goods/components/item-detail/item-scope-toolbar';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { useGetPurchasedPackagingItemInsights } from '@shared/api/hooks/purchased-goods/item-insights';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../purchased-goods-routes';
import { getPackagingReferrerLabel } from '../utils';
import { usePurchasedPackagingItem } from './purchased-packaging-item-context';
import { usePurchasedPackagingItemsTabs } from './tabs';

export default function PurchasedPackagingItemLayout() {
  const { item, status, referrer, packagingActivityUuid } =
    usePurchasedPackagingItem();
  const tabs = usePurchasedPackagingItemsTabs();
  const navigate = useNavigate();
  const { insightsParams } = useItemScope();
  const { data: insights } = useGetPurchasedPackagingItemInsights(
    packagingActivityUuid ?? '',
    insightsParams
  );

  return (
    <Page
      name={item?.packagingName}
      page="layout"
      status={status}
      title={`${item?.packagingName} - Purchased Packaging`}
      flexFullHeight
    >
      <PageHeader
        name={item?.packagingName}
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Purchased goods',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_PACKAGING),
          },
          {
            label: 'Packaging',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_PACKAGING),
          },
          {
            label: item?.packagingName || 'Item',
            url: generatePath(purchasedGoodsRoutes.PURCHASED_PACKAGING_ITEM, {
              item_uuid: item?.uuid || '',
            }),
          },
        ]}
        toolbar={
          <div className="flex flex-wrap items-center justify-end gap-2">
            {referrer ? (
              <Button
                variant="ghost"
                onClick={() => navigate(referrer)}
                icon={<Icons.chevronLeft className="size-4" />}
              >
                {getPackagingReferrerLabel(referrer)}
              </Button>
            ) : null}
            <ItemScopeToolbar
              defaultStart={insights?.timePeriodStart}
              defaultEnd={insights?.timePeriodEnd}
              siteOptions={insights?.availableFilters.sites}
            />
          </div>
        }
      />
      <Outlet />
    </Page>
  );
}
